import { render } from "./DashboardSideMenu.component.vue?vue&type=template&id=21a5c357"
import script from "./DashboardSideMenu.component.vue?vue&type=script&lang=js"
export * from "./DashboardSideMenu.component.vue?vue&type=script&lang=js"

import "./DashboardSideMenu.component.vue?vue&type=style&index=0&id=21a5c357&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QList,QItem,QItemSection,QIcon,QBadge});
